import React,{ useState } from 'react';
import './App.css';
import Search from './search';
import { Card } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { DiAndroid } from 'react-icons/di';
import { BsGlobe2, BsApple, BsFillCaretDownSquareFill } from 'react-icons/bs';
import { posts } from './posts';
import { reviews } from './reviews';

const filterPosts = (posts, query) => {
  if (!query) {
    return posts;
  }

  return posts.filter((post) => {
    const postTitle = post.title.toLowerCase();
    return postTitle.includes(query);
  });
};

const App = () => {
  const { search } = window.location;
  const query = new URLSearchParams(search).get('s');
  const [searchQuery, setSearchQuery] = useState(query || '');
  const filteredPosts = filterPosts(posts, searchQuery);

  return (
    <div className="App container mt-5">
      <p><a href="https://www.youtube.com/channel/UCQNE2JmbasNYbjGAcuBiRRg">조코딩 유튜브 채널</a></p>
      <p><a href="https://jocodinguserevent.netlify.app/">10만 이벤트 작품보기</a></p>
      <p><a href="https://jocodingtestevent.netlify.app/">20만 이벤트 작품보기</a></p>
      <h1 className="pb-3">조코딩 30만 구독자 이벤트 응모 작품 모음</h1>
      <iframe width="560" height="315" src="https://www.youtube.com/embed/iIEMS2FcDp0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      <h2 className="pt-3"><BsFillCaretDownSquareFill />영상 리뷰에 나온 28개 작품<BsFillCaretDownSquareFill /></h2>
      <ol>
        {reviews.map((review,index) => (
          <Card className="mt-3" style={{ width: '80%', margin: '0 auto' }} key={index}>
            <Card.Img variant="top" src="" />
            <Card.Body>
              <Card.Title className="font-weight-bold">{review.id+". "+review.title}</Card.Title>
              <Card.Text>
                {review.description}
              </Card.Text>
              { review.webURL && <a href={review.webURL} target="_blank" rel="noopener noreferrer"><BsGlobe2 size="32"/></a>}
              { review.androidURL && <a href={review.androidURL} target="_blank" rel="noopener noreferrer"><DiAndroid size="36" color="#30d780"/></a>}
              { review.iosURL && <a href={review.iosURL} target="_blank" rel="noopener noreferrer"><BsApple size="36" color="#555"/></a>}
            </Card.Body>
          </Card>
        ))}
      </ol>
      <hr/>
      <h2><BsFillCaretDownSquareFill />응모 작품 전체 보기<BsFillCaretDownSquareFill /></h2>
      <Search
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
      />
      <ul>
        {filteredPosts.map((post,index) => (
          <Card className="mt-3" style={{ width: '80%', margin: '0 auto' }} key={index}>
            <Card.Img variant="top" src="" />
            <Card.Body>
              <Card.Title className="font-weight-bold">{post.title}</Card.Title>
              <Card.Text>
                {post.description}
              </Card.Text>
              { post.webURL && <a href={post.webURL} target="_blank" rel="noopener noreferrer"><BsGlobe2 size="32"/></a>}
              { post.androidURL && <a href={post.androidURL} target="_blank" rel="noopener noreferrer"><DiAndroid size="36" color="#30d780"/></a>}
              { post.iosURL && <a href={post.iosURL} target="_blank" rel="noopener noreferrer"><BsApple size="36" color="#555"/></a>}
            </Card.Body>
          </Card>
        ))}
      </ul>
    </div>
  );
};

export default App;